import styled from 'styled-components';

const ProgramPageHolder = styled.div`
	grid-area: content;
	overflow: auto;
	width: 100%;
	margin: 0 auto;
	.show-thumbnail {
		background-color:white;
		padding-bottom: 20px;
			img {
				width:100%;
			}
		&.content__left {
			a {
				text-decoration: none;
				position: relative;
			}
		}
	}
	.show-latest-episodes {
		background: white;
		.content__left {
			width: calc(75%); 
			margin-top: 0px;
			@media only screen and (max-width: 920px) {
				width: 100%;
			}
		}
		.content__right {
			margin-top: 0px;
			margin-left: 0px;
		}
    }
	@media only screen and (max-width: 920px) {
		.content__left .show-latest-episode {
            bottom: 0px;
       } 
    }
	.show-latest-episode
	{
		padding: 10px 30px;
		display: flex;
		background-color: rgba(0,0,0,.8);
		position: absolute;
        width: 100%;
        bottom: 4px;
        img {
			width:110px;
	    }
	}	
	.watch-title {
		color: white;
		font-weight: normal;
	}
	.social-share {
		padding-left: 30px;
		padding-right: 30px;
	}

    .show-title-description {
		padding-left: 30px;
		padding-right: 30px;
		p {
			color: #606060;
		}
	}	
	.play-button-watch-title {
		display: flex;
		align-items: baseline;
		h2 {
			margin-bottom: 5px;
        	margin-left: 5px;
		}
	}	
	.latest-episode-thumbnail {
		margin-right: 20px;
	}
	.latest-episode-info {
		h2 {
			color: white;
			font-size: 24px;
			font-weight: normal;
			margin-top: 0px;

			@media only screen and (max-width: 548px) {
				font-size: 16px;
			}

		}
		span {
			color: white;
			font-size: 20px;
			@media only screen and (max-width: 548px) {
				font-size: 14px;
			}
		}
		button[name="play"] {
			width: 23px;
			height: 23px;
			background: #7a7652;
			border: none;
			border-radius: 100%;
			cursor: pointer;
			&:focus {
				outline: 0;
				border: 1px solid hsl(210, 58%, 69%);
				box-shadow: 0 0 0 3px hsla(210, 76%, 57%, 0.5);
			}
			&::after {
				content: '';
				display: inline-block;
				position: relative;
				top: 1px;
				left: 1px;
				border-style: solid;
				border-width: 5px 0 5px 10px;
				border-color: transparent transparent transparent white;
			}
		}
	}
	.host-bio {
		max-width: 100%;
		margin: 0 auto;
		@media (min-width: 768px) {
			margin: 0 auto 0 auto;
		}
		&:nth-child(even) {
			@media (min-width: 768px) {
				margin-left: .5rem;
			}
		}
		&:nth-child(odd) {
			@media (min-width: 768px) {
				margin-right: .5rem;
			}
		}
		
	}	
	.pgm-aboutHost {
		width: 100%;
		display:grid;
		grid-template-columns: 50% 50%;
		padding: 0 1rem; 
		@media (max-width: 767px) {
			width: 100%;
			display:block;
			padding: 0 2rem;
		}
		
		p {
			padding: 5px;
		}
	}
	.pgm-about-host-label {
		color: #fff;
		background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
		background-size: auto 110%;
		padding: 8px 20px 8px 40px;
		width: 100%;
		border-radius: 2em;
		text-transform: uppercase;
		margin: 40px 0 20px;
		font-size: 20px;
		@media (max-width: 767px) {
			margin: 20px auto;
			width: 100%;
		}
	}
	.host-image-container {
		padding-top: 0 !important;
		display: block;
		margin: 0;
		position:relative;
		img {
			max-width: 100%;
			margin-top: 1px;
			
		}
	}
`;

export default ProgramPageHolder;


